/**
 * Storage utilities for managing redirect paths during authentication.
 * This module handles saving and retrieving the intended navigation path
 * before Auth0 redirect, and clearing it after successful authentication.
 */

const REDIRECT_PATH_KEY = 'auth_redirect_path';

/**
 * Saves the current path to sessionStorage so it can be retrieved
 * after authentication completes.
 * @param path - The path to save for post-authentication redirect
 */
export const saveRedirectPath = (path: string): void => {
    if (typeof window !== 'undefined') {
        try {
            sessionStorage.setItem(REDIRECT_PATH_KEY, path);
        } catch {
            // sessionStorage might not be available (e.g., in private browsing)
            // Silently fail as this is not critical
        }
    }
};

/**
 * Retrieves the saved redirect path from sessionStorage.
 * @returns The saved path or null if not found
 */
export const getRedirectPath = (): string | null => {
    if (typeof window !== 'undefined') {
        try {
            return sessionStorage.getItem(REDIRECT_PATH_KEY);
        } catch {
            return null;
        }
    }
    return null;
};

/**
 * Clears the saved redirect path from sessionStorage.
 */
export const clearRedirectPath = (): void => {
    if (typeof window !== 'undefined') {
        try {
            sessionStorage.removeItem(REDIRECT_PATH_KEY);
        } catch {
            // Silently fail
        }
    }
};
